import PropTypes from 'prop-types'
import { styled } from '@mui/material/styles'

const ContainerRoot = styled('div')({
  width: '100%',
  paddingLeft: '20px',
  paddingRight: '20px',
  paddingTop: '32px',
  paddingBottom: '24px',
  border: '1px solid #dee2e6',
  borderRadius: '5px',
  backgroundColor: '#fff',
})

const FormContainer = ({ children }) => {
  return <ContainerRoot>{children}</ContainerRoot>
}
FormContainer.propTypes = {
  children: PropTypes.any,
}
export { FormContainer }
